import { Box } from "@chakra-ui/layout";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useLayoutEffect, useState } from "react";
import { useSegmentedMessage } from "src/hooks/useSegmentedMessage";
import { editorStateToPlainText } from "../../utils/converters";
import { SegmentedMessageStats } from "./SegmentedMessageStats";

export default function SegmentedMessagePlugin(): JSX.Element {
  const [editor] = useLexicalComposerContext();
  const [rawText, setRawText] = useState("");

  useLayoutEffect(() => {
    return editor.registerUpdateListener(
      ({ editorState, dirtyElements, dirtyLeaves, prevEditorState, tags }) => {
        if (
          (dirtyElements.size === 0 && dirtyLeaves.size === 0) ||
          tags.has("history-merge") ||
          prevEditorState.isEmpty()
        ) {
          return;
        }

        setRawText(editorStateToPlainText(editorState));
      }
    );
  }, [editor]);

  const { segmentedMessage } = useSegmentedMessage({ text: rawText });

  return (
    <Box pt={2} pb={2} px={4} borderTop="1px solid" borderColor="gray.200">
      <SegmentedMessageStats
        characterCount={segmentedMessage.numberOfCharacters}
        segmentCount={segmentedMessage.segmentsCount}
        isOverflowing={segmentedMessage.isOverflowing()}
        characterLimit={segmentedMessage.characterLimit()}
        isUCS2={segmentedMessage.isUCS2()}
      />
    </Box>
  );
}
